<template>
    <div class="custom-datepicker">
        <VueCtkDateTimePicker
            v-model="model"
            :no-header="true"
            :no-label="true"
            color="indigo"
            :no-button-now="noButton"
            :formatted="dateFormat"
            :format="formatVal"
            :only-date="date"
            :only-time="time"
            :auto-close="close"
            :no-button="noFooter"
        >
            <input
                id="DateTimePicker"
                placeholder="Select date"
                type="text"
                readonly="readonly"
                :class="[{ 'disable-input': customDisable }, 'field-input']"
            />
        </VueCtkDateTimePicker>
        <i :class="[{ 'disable-input': customDisable }, 'icon-calendar']"></i>

        <p v-if="value == null" class="placeholder">
            {{ placeholder }}
        </p>
    </div>
</template>
<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
export default {
    components: {
        VueCtkDateTimePicker,
    },
    props: {
        /**
         * Value to determine the current compose mode which
         * varies between 'add' and 'edit'
         */
        dateFormat: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        formatVal: {
            type: String,
            default: null,
        },
        date: {
            type: Boolean,
            default: false,
        },
        time: {
            type: Boolean,
            default: false,
        },
        close: {
            type: Boolean,
            default: false,
        },
        noButton: {
            type: Boolean,
            default: true,
        },
        noFooter: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
        },
        customDisable: {
            type: Boolean,
            default: false,
        },
    }, // End of Component > props
    data() {
        return {}
    },
    computed: {
        model: {
            /**
             * Getter to get value for computed property
             * using props from parent componennt
             *
             * @return {mix}
             */
            get: function () {
                return this.value
            }, // End of get() method
            /**
             * Setter to set value for computed property
             * notifying the parent component
             *
             * @return {void}
             */
            set: function (newValue) {
                this.$emit('input', newValue)
            }, // End of set() method
        },
    },
}
</script>
